

/** @type {import('./abs')} */
module.exports = Math.abs;




//////////////////
// WEBPACK FOOTER
// ../node_modules/math-intrinsics/abs.js
// module id = ../node_modules/math-intrinsics/abs.js
// module chunks = 1